<template>
    <v-card color="grey lighten-2" width="100%" flat tile>
        <v-card-text>
            <v-row class="justify-center">
                <a href="http://www.quixada.ufc.br" target="_blank">Universidade Federal do Ceará - Campus Quixadá </a>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'LinksComponent',
    }
</script>

<style lang="sass" scoped>
  a
    color: inherit !important
</style>
